import RefinementList from "./RefinementList";
import { Sheet, SheetContent, SheetHeader,SheetFooter, SheetPortal, SheetTitle, SheetTrigger, SheetClose } from "./ui/Sheet";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/Accordion";
import { useState } from "react";
import { useClearRefinements } from "react-instantsearch";
import RefinementToggle from "./RefinementToggle";
import RefinementListToggle from "./RefinementListToggle";
import FiltersIcon from "../icons/FiltersIcon";
import { SortByFilter } from "./SortByFilter";
import { FilterAttribute, useVirtualFilters, toggleFilters } from "../../search-shared/VirtualFilters";
import { ScrollArea } from "../../components/ui/ScrollArea";
import InStockFilter from "./InStockFilter";


interface AccordionItemData {
    value: string;
    label: string;
    attribute: FilterAttribute;
    canRefine: boolean;
}

export default function Filters() {
    const filters = useVirtualFilters();
    const { hasRefinements, canRefine, refine } = useClearRefinements();
    const [accordionState, setAccordionState] = useState(filters.category.canRefine ? ["category"] : []);

    const accordionData: AccordionItemData[] = [
        // {
        //     value: 'category',
        //     label: window.algoliaShopify?.config?.filterOptions?.category || 'Category',
        //     attribute: FilterAttribute.CATEGORY,
        //     canRefine: filters.category.canRefine,
        // },
        {
            value: 'type',
            label: window.algoliaShopify?.config?.filterOptions?.productType || 'Type',
            attribute: FilterAttribute.PRODUCT_TYPE,
            canRefine: filters.productType.canRefine,
        },
        {
            value: 'room',
            label: window.algoliaShopify?.config?.filterOptions?.room || 'Room',
            attribute: FilterAttribute.ROOM,
            canRefine: filters.room.canRefine,
        },
        {
            value: 'range',
            label: window.algoliaShopify?.config?.filterOptions?.range || 'Range',
            attribute: FilterAttribute.RANGE,
            canRefine: filters.range.canRefine,
        },
        {
            value: 'colour',
            label: window.algoliaShopify?.config?.filterOptions?.colour || 'Colour',
            attribute: FilterAttribute.COLOUR,
            canRefine: filters.colour.canRefine,
        },
        {
            value: 'brand',
            label: window.algoliaShopify?.config?.filterOptions?.brand || 'Brand',
            attribute: FilterAttribute.BRAND,
            canRefine: filters.brand.canRefine,
        },
        {
            value: 'designer',
            label: window.algoliaShopify?.config?.filterOptions?.designer || 'Designer',
            attribute: FilterAttribute.DESIGNER,
            canRefine: filters.designer.canRefine,
        }
    ];

    return (
        <Sheet>
            <SheetTrigger className="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-rounded-full tw-bg-white tw-text-sm tw-font-[500] tw-whitespace-nowrap tw-text-nowrap">
                <FiltersIcon /> All Filters
            </SheetTrigger>

            <SheetPortal>
                <SheetContent side="left" className="tw-flex tw-flex-col tw-bg-white tw-p-3 tw-pr-2 tw-w-full sm:tw-max-w-[400px] tw-font-body">
                    <SheetHeader className="tw-py-2">
                        <div className="tw-flex tw-flex-row tw-justify-between tw-pb-3 tw-pr-10">
                            <SheetTitle>Filters</SheetTitle>
                        </div>
                    </SheetHeader>

                    <ScrollArea className="tw-flex-1 tw-w-full tw-pr-1" scrollHideDelay={200}>
                        <Accordion
                            type="multiple"
                            onValueChange={setAccordionState}
                            defaultValue={accordionState}
                        >
                            <AccordionItem
                                key="sort"
                                value="sort"
                                className="tw-group tw-border-b first:tw-border-t"
                            >
                                <AccordionTrigger className="tw-text-sm tw-font-medium group-data-[disabled]:tw-cursor-not-allowed tw-py-4">
                                    Sort
                                </AccordionTrigger>

                                <AccordionContent>
                                    <SortByFilter />
                                </AccordionContent>
                            </AccordionItem>

                            {accordionData.map((item) => (
                                <AccordionItem
                                    key={item.value}
                                    value={item.value}
                                    disabled={!item.canRefine}
                                    className="tw-group tw-border-b first:tw-border-t"
                                >
                                    <AccordionTrigger className="tw-text-sm tw-font-medium group-data-[disabled]:tw-cursor-not-allowed tw-py-4">
                                        {item.label}
                                    </AccordionTrigger>

                                    <AccordionContent>
                                        <RefinementList attribute={item.attribute} />
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>

                        {toggleFilters.map((item) => {
                            const componentProps = {
                                attribute: item.attribute,
                                className: "tw-py-4 tw-w-full tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium group-data-[disabled]:tw-cursor-not-allowed tw-border-b last:tw-border-none",
                                children: <div>{item.label}</div>
                            };

                            if(item.type === 'inStock') {
                                return (
                                    <InStockFilter
                                        key={item.label}
                                        {...componentProps}
                                        min={item.min || 1}
                                    />
                                );
                            }

                            return item.type === 'refinementList' ? (
                                <RefinementListToggle 
                                    key={item.label}
                                    {...componentProps}
                                    value={item.on as string}
                                />
                            ) : (
                                <RefinementToggle 
                                    key={item.label}
                                    {...componentProps}
                                    on={item.on}
                                />
                            );
                        })}
                    </ScrollArea>
                    <SheetFooter className="tw-flex tw-justify-evenly tw-space-x-2 tw-py-4">
                        {hasRefinements && canRefine && <button className="tw-px-2 tw-text-2xs" onClick={() => refine()}>Clear All</button>}
                        <SheetClose asChild>
                            <button className="tw-border tw-bg-black tw-text-white tw-px-4 tw-py-2 tw-text-sm tw-font-medium">
                                Apply Filters
                            </button>
                        </SheetClose>
                    </SheetFooter>
                </SheetContent>
            </SheetPortal>
        </Sheet>
    )
}